import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import EmptyRow from './EmptyRow'

interface Props {
  label: string
}

const EmptyState = ({ label }: Props) => {
  return (
    <Box
      gap="s8"
      padding="s24"
      flexDirection="column"
      justifyContent="flexStart"
      alignItems="center"
    >
      <Box width="s360" flexDirection="row" justifyContent="flexStart" alignItems="center">
        <Text.Normal>{label}</Text.Normal>
      </Box>
      <EmptyRow />
    </Box>
  )
}

export default observer(EmptyState)
